module.exports = __webpack_public_path__ + "static/media/sponcer_ColorStreet.dab80b97.png";